import axios from 'axios';
import Vue from 'vue'

export default {

    findItems (page, pageSize,selectedBrand,reference, selectedGroup, selectedSubGroup, selectedPromotion, requestTimestamp) {
        return axios.get('/api/items/list', { params: {page: page, pageSize: pageSize,selectedBrand:selectedBrand,reference:reference, selectedGroup:selectedGroup, selectedSubGroup:selectedSubGroup, selectedPromotion:selectedPromotion, requestTimestamp:requestTimestamp} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    findItemsByOEM (page, pageSize,selectedBrand,oemReference) {
        return axios.get('/api/items/oems/list', { params: {page: page, pageSize: pageSize,selectedBrand:selectedBrand,oemReference:oemReference} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    findItemsByVIN (page, pageSize,selectedBrand, vinSubGroup,vin) {
        return axios.get('/api/items/vin/list', { params: {page: page, pageSize: pageSize,selectedBrand:selectedBrand, vinSubGroup:vinSubGroup, vin:vin} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    findItemsByVehicules (page, pageSize,selectedBrand,selectedManufacturer,selectedVehiculeModel,selectedMotorizationType) {
        return axios.get('/api/items/vehicules/list', { params: {page: page, pageSize: pageSize,selectedBrand:selectedBrand,manufacturer:selectedManufacturer,model:selectedVehiculeModel,vehicule:selectedMotorizationType} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getItemsOEMs (itemId) {
        return axios.get('/api/items/oems/', { params: {itemId:itemId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getItemsManufacturers (itemId) {
        return axios.get('/api/items/manufacturers/list', { params: {itemId:itemId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getGroups () {
        return axios.get('/api/items/groups/')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getSubGroups (group) {

        if (group != null) {
            return axios.get('/api/items/subgroups/', { params: {groupId:group.id} })
            .then(response => {
                if (response && response.data) return response.data
            })
            .catch(error => {Vue.prototype.$snotify.error(error);})
        }
    },

    getManufacturers () {
        return axios.get('/api/items/manufacturers/')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getCarMakes(page, pageSize, filter){
        return axios.get('/api/items/car-makes/list', {params: {page:page, pageSize:pageSize, filter:filter}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    getModels (manufacturerId) {
        return axios.get('/api/items/models/', { params: {manufacturerId:manufacturerId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getVehicules (modelId) {
        return axios.get('/api/items/vehicules/', { params: {modelId:modelId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getSimilairItems (page, pageSize,itemId) {
        return axios.get('/api/items/similair/', { params: {page: page, pageSize: pageSize,itemId:itemId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getKit (page, pageSize,itemId) {
        return axios.get('/api/items/kit/', { params: {page: page, pageSize: pageSize,itemId:itemId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getComponents (itemId) {
        return axios.get('/api/items/components/', { params: {itemId:itemId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getImportQty (itemId) {
        return axios.get('/api/items/import-quantity/', { params: {itemId:itemId} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getCategories (level, customerId, parentId, page, pageSize) {
        return axios.get('/api/items/categories', { params: { level: level, customerId: customerId, parentId: parentId, page: page, pageSize: pageSize } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },


    getSupplierItems (supplierId) {
        return axios.get('/api/items/list',{params: {supplierId: supplierId}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    }, 

    getMaxFileSize() {
        return axios.get('/api/items/size')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },



    getBrands(page, pageSize, filter){
        return axios.get('/api/items/brand/list', {params: {page:page, pageSize:pageSize, filter:filter}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    getAllBrands(onlyVisible){
        return axios.get('/api/items/brand/all', {params: {onlyVisible:onlyVisible}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    findVinDetails(vin) {
        return axios.get('/api/items/vindetails', {params: {vin: vin}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getVinSubGroups() {
        return axios.get('/api/items/vinsubgroups')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getClaimTypes() {
        return axios.get('/api/items/claim/type')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    submitClaim(claimTypeId, itemId, itemRef, details, brandId, refType) {

        var claim = {claimTypeId: claimTypeId, itemId: itemId, itemRef: itemRef, details: details, brandId:brandId, refType:refType};
        return axios.post('/api/items/claim/submit', claim)
            .then(response => {
                if (response && response.data) {
                    if (response.data) {
                        Vue.prototype.$snotify.success("Réclamation n° " + response.data + " envoyée !");
                    }
                    return response.data;
                }
            })
            .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getAttributes(itemId) {
        return axios.get('/api/items/attributes?itemId=' + itemId)
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    }
}

